import type { ServiceDto } from '../Service';
import Services from '../Services';
import { StorageProvider } from '../types';
import BunnyStorage from './BunnyStorage';
import PulseCdnStorage from './PulseCdnStorage';
import S3Storage from './S3Storage';
import type { AnyStorageType } from './types';

export default class Storages extends Services<AnyStorageType> {
  declare selectedProvider?: StorageProvider;

  protected unserialize(dto: ServiceDto): AnyStorageType {
    switch (dto.provider) {
      case 'bunnycdn.com': {
        return new BunnyStorage(dto, this.save);
      }
      case 'pulsecdn.net': {
        return new PulseCdnStorage(dto, this.save);
      }
      default: {
        return new S3Storage(dto, this.save);
      }
    }
  }
}
